
import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';

import { MagentoLinkedService } from 'app/model/linkedservice/magento.linkedservice';
import { TabularTypeDataset } from './tabular-type.dataset';
import { format } from 'app/shared/utils/string.util';

@Metamodel.model({
    name: 'MagentoObject',
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.Magento_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.Magento_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: MagentoLinkedService.MODEL // Linked service redefined
        }
    }
})
export class MagentoObjectDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;

    public constructor(name?: string, description?: string) {
        super(name, description);
    }
}
